import { createSelector } from '@reduxjs/toolkit';
import { selectFloor, selectFloorTypes } from 'shared/selectors/jsonQuery';
import { EFloorTypes } from '../../../../packages/api-models/common/json_query';

export const selectFloorCommercialFilter = createSelector(
  [selectFloor, selectFloorTypes],
  ({ gte = null, lte = null }, floorTypes) => ({
    label: 'Этаж',
    value: { min: gte, max: lte },
    min: 1,
    max: 200,
    onlyFirstFloor: floorTypes?.includes(EFloorTypes.OnlyFirstFloor) ?? false,
    notBasement: floorTypes?.includes(EFloorTypes.NotBasement) ?? false,
  }),
);
